<template>
  <div id="customtag" style="width: 100%;">
    <div class="registerform-input-container">
      <div class="title align-items-center">
        <div class="custom-label" style="margin-bottom:0px">
          <label>{{ $t("contentManagement.eventProgram.components.tags")}}</label>
          <!-- <el-tooltip content="Content" placement="bottom">
            <i class="el-icon-info"></i>
          </el-tooltip> -->
        </div>
        <div>
          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
            <el-button @click="getCustomTags" size="mini" icon="fas fa-redo-alt" circle type="success" style="border: none" :loading="loading == 'getCustomTags'"> </el-button>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top" v-if="values.length == 1">
            <el-button circle type="primary" @click="addModal(tags.find((k) => k.id == values[0]))" size="mini" style="border: none">
              <i class="fas fa-pen"></i>
            </el-button>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" :content="$t('event.buttons.addNew')" placement="top">
            <el-button @click="addModal(null)" type="primary" circle size="mini" style="border: none">
              <i class="fas fa-plus"></i>
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <el-select multiple v-model="values" v-if="tags">
        <el-option v-for="item in tags" :value="item.id" :label="item.title" :key="item.id+'-custom-tag-list'"></el-option>
      </el-select>
    </div>

    <el-dialog :append-to-body="true" :visible.sync="modal" class="medium" :title="$t('event.tags.editLabel')" @before-close="form = null">
      <div class="custom-modal">
        <div class="modal-body">
          <transition name="el-fade-in" mode="out-in">
            <HolaconLottie v-if="loading == 'updateScreenLoading' && form == null" key="create-loading"  />
            <el-row v-else-if="loading != 'updateScreenLoading' && form != null" key="content-loading">
              <input autocomplete="false" name="hidden" type="text" style="display: none" />

              <div class="row">
                <div class="form-group col-md-12">
                  <label>{{ this.$t('event.table.title') }}</label>
                  <el-input placeholder="" v-model="form.title" :class="$inputError('title', validationErrors)"></el-input>
                  <span class="error">{{ $errorMessage('title', validationErrors) }}</span>
                </div>
              </div>
            </el-row>
          </transition>
        </div>
        <div class="modal-footer" slot="footer" v-if="loading != 'updateScreenLoading' && form != null">
          <div class="left-buttons">
            <el-button @click="modal = false">{{ $t("contentManagement.eventProgram.components.close")}}</el-button>
            <template v-if="form.id != null">
              <el-popconfirm @confirm="deleteCustomTag(form.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                <el-button slot="reference" type="danger" icon="fas fa-trash"> {{ $t("contentManagement.eventProgram.components.delete")}}</el-button>
              </el-popconfirm>
            </template>
          </div>
          <div class="right-buttons">
            <el-button type="primary" :loading="loading == 'saveLoading'" :disabbled="loading == 'saveLoading'" @click="save">{{ $t("contentManagement.eventProgram.components.save")}}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import axios from 'axios';
  export default {
    name: 'CustomTag',
    props: ['value'],
    data() {
      return {
        tags: [],
        modal: false,
        form: null,
        loading: false,
        validationErrors: [],
        values: [],
        timeout: null,
      };
    },
    async created() {
      this.values = this.value.map((k) => k.id);
      await this.getCustomTags();
    },
    methods: {
      async getCustomTags() {
        this.loading = 'getCustomTags';
        var res = await axios.post('customtag/list', { skip: 0, take: 1000 });
        this.tags = res.data.data.items;
        this.$emit(
          'input',
          this.tags.filter((k) => this.values.indexOf(k.id) != -1),
        );
        this.loading = false;
      },
      async save() {
        this.loading = 'saveLoading';
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          var res = await axios.post('customtag/addorupdate', this.form);
          this.loading = false;
          this.validationErrors = res.data.validationErrors;

          if (res.data.alert.hasError == true) {
            this.$message.error(res.data.alert.message);
          } else {
            if (this.form.id == null) {
              this.form = {
                title: null,
                color: '#ddd',
              };
            }
            await this.getCustomTags();
            this.$message.success(res.data.alert.message);
            this.modal = false;
          }
        }, 500);
      },
      async deleteCustomTag(id) {
        this.loading = 'deleteCustomTag';
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await axios.post('customtag/delete', { id: this.form.id });
          await this.getCustomTags();
          if (this.value == id) {
            this.value = null;
          }
          await this.getCustomTags();
          this.modal = false;
          this.form.id = null;
          this.values = [];
          this.loading = false;
        }, 500);
      },
      addModal(edit) {
        this.modal = true;
        this.loading = 'updateScreenLoading';
        if (this.timeout) clearTimeout(this.timeout);
        this.validationErrors = [];
        this.timeout = setTimeout(() => {
          if (edit != null) {
            this.form = edit;
          } else {
            this.form = {
              title: null,
              color: '#ddd',
              id: null,
            };
          }
          this.loading = false;
        }, 1000);
      },
    },
    mounted() {},
    watch: {
      modal: {
        handler() {
          if (this.modal == false) {
            this.form = null;
          }
        },
      },
      values: {
        handler: function() {
          this.$emit(
            'input',
            this.tags.filter((k) => this.values.indexOf(k.id) != -1),
          );
        },
        deep: true,
      },
    },
  };
</script>
<style lang="less">
  .registerform-input-container {
    .tag-container {
      gap: 1rem;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    .badge-list {
      display: flex;
      flex-direction: row;
      gap: 1rem;
      .badger {
        border-radius: 8px;
        background-color: #f3f3f3;
        height: 20px;
        padding: 10px;
      }
    }
    .title {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;
      label {
        font-weight: bold;
        color: black;
        margin-bottom: 0;
      }
      .title-container {
        display: flex;
        flex-direction: row;
        gap: 1rem;
        align-items: center;
      }
    }
    display: flex;
    flex-direction: column;
    .el-input-number {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CustomTag.vue